import { graphql, Link, StaticQuery } from "gatsby"
import Img from "gatsby-image"
import React, { Component } from "react"

import * as contactStyles from "../styles/contacts.module.css"

const query = graphql`
  query SocialsQuery {
    dataJson(title: { eq: "Social Media" }) {
      socials {
        handle
        name
        url
        img {
          childImageSharp {
            fluid {
              src
            }
          }
        }
      }
    }
  }
`

class Contact extends Component {
  render() {
    return (
      <StaticQuery
        query={query}
        render={data => (
          <React.Fragment>
            <div
              className="container"
              data-sal="fade"
              data-sal-delay="50"
              data-sal-easing="ease"
            >
              <div className={contactStyles.divider}></div>
              <div className={contactStyles.title}>
                Contact
                <div className={contactStyles.desc}>
                  &lt;Reach out to me!/&gt;
                </div>
              </div>
            </div>
            <div className={contactStyles.textDiv}>
              <h1 className="text text-center">Hit me up with anything.</h1>
            </div>
            <div className={contactStyles.socialDiv}>
              {data.dataJson.socials.map(social => (
                <React.Fragment>
                  <div key={social.url}>
                    <a href={social.url}>
                      <Img
                        className={contactStyles.img}
                        fluid={social.img.childImageSharp.fluid}
                        alt={social.handle}
                        title={`${social.handle} on ${social.name}`}
                      />
                    </a>
                  </div>
                </React.Fragment>
              ))}
            </div>
            <div className={contactStyles.textDiv}>
              <div className="text text-center mt-4">
                <Link to="/series">Bears. Beets. Battlestar Gallactica.</Link>
              </div>
            </div>
          </React.Fragment>
        )}
      />
    )
  }
}

export default Contact
